import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button, Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useCart } from '../contexts/CartContext';
import { useBranding } from '../contexts/BrandingContext';

const Navigation = () => {
  const { user, logout, isAdmin } = useAuth();
  const { language, setLanguage, t } = useLanguage();
  const { cartItems, cartCount } = useCart();
  const { branding } = useBranding();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'fi' : 'en');
  };

  return (
    <Navbar className="navbar-tonisco" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          {branding.logo_url ? (
            <img
              src={branding.logo_url}
              alt="Tonisco"
              className="brand-logo"
            />
          ) : (
            <>
              <img
                src="/img/Tonisco-logo-wide-website-2048x649.png"
                alt="Tonisco"
                className="brand-logo"
              />
              <span className="brand-text">Tonisco</span>
            </>
          )}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">{t('nav.home')}</Nav.Link>
            {user && (
              <>
                <Nav.Link as={Link} to="/products">{t('nav.products')}</Nav.Link>
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Popover className="cart-popover">
                      <Popover.Header as="h3">{t('nav.cart')}</Popover.Header>
                      <Popover.Body>
                        {cartItems.length === 0 ? (
                          <div className="text-muted">{t('cart.empty')}</div>
                        ) : (
                          <>
                            {cartItems.map((item) => (
                              <div key={item.id} className="cart-popover-item">
                                <div className="cart-popover-name">{item.product?.name}</div>
                                <div className="cart-popover-meta">
                                  {t('cart.quantity')}: {item.quantity}
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <Nav.Link as={Link} to="/cart" className="cart-link">
                    {t('nav.cart')}
                    {cartCount > 0 && (
                      <Badge bg="danger" pill className="cart-badge">
                        {cartCount}
                      </Badge>
                    )}
                  </Nav.Link>
                </OverlayTrigger>
                <Nav.Link as={Link} to="/orders">{t('nav.orders')}</Nav.Link>
                  <Nav.Link as={Link} to="/profile">{t('nav.profile')}</Nav.Link>
              </>
            )}
            {isAdmin() && (
              <Nav.Link as={Link} to="/admin">{t('nav.admin')}</Nav.Link>
            )}
          </Nav>
          <Nav>
            <Button 
              variant="outline-light" 
              size="sm" 
              onClick={toggleLanguage}
              className="me-2"
            >
              {language === 'en' ? 'FI' : 'EN'}
            </Button>
            {user ? (
              <>
                <Navbar.Text className="me-3">
                  {user.username} {isAdmin() && <Badge bg="danger">Admin</Badge>}
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  {t('nav.logout')}
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/login">{t('nav.login')}</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
